import {
  convertFromRaw,
  EditorState,
  genKey,
  Modifier,
  RawDraftContentState,
  SelectionState,
} from 'draft-js';
import { Mentions } from './MentionsEditor';

export const generateEditorStateWithMentions = (mention: Mentions) => {
  const rawContentState: RawDraftContentState = {
    blocks: [
      {
        key: genKey(),
        text: mention.name,
        type: 'unstyled',
        inlineStyleRanges: [],
        data: {},
        depth: 0,
        entityRanges: [{ offset: 0, length: mention.name.length, key: 0 }],
      },
    ],
    entityMap: {
      '0': {
        type: 'mention',
        mutability: 'MUTABLE',
        data: {
          mention: { ...mention, name: `${mention.name}` },
        },
      },
    },
  };

  const state = EditorState.push(
    EditorState.createWithContent(convertFromRaw(rawContentState)),
    convertFromRaw(rawContentState),
    'insert-characters',
  );

  const currentContent = state.getCurrentContent();
  const blockMap = currentContent.getBlockMap();
  const key = blockMap.last().getKey();

  const length = blockMap.last().getLength();
  const selection = new SelectionState({
    anchorKey: key,
    anchorOffset: length,
    focusKey: key,
    focusOffset: length,
  });

  const textWithInsert = Modifier.insertText(currentContent, selection, ' ', undefined);
  const editorWithInsert = EditorState.push(state, textWithInsert, 'insert-characters');
  const newEditorState = EditorState.moveSelectionToEnd(editorWithInsert);

  return newEditorState;
};
